const getRoute = (state: any) => (id: number) => {
  return state.routes.find((el: any) => el.id == id);
};

export default {
  getRoute,
};
